// extracted by mini-css-extract-plugin
export var fullGrid = "_32-3";
export var pdpPreviewContainer = "_32-1";
export var previewContainer = "_32-0";
export var togglePreviewContainer = "_32-2";